/* Keep embedded charts readable on small screens without altering their data. */
function vyvPrepareArticleCharts() {
  document.querySelectorAll('.vf-article .vyv-viz svg, .vf-article .vyv-ferm-viz svg').forEach(function (chart) {
    if (chart.parentElement.classList.contains('vf-chart-scroll')) return;
    if (!chart.viewBox.baseVal || chart.viewBox.baseVal.width < 500) return;
    var panel = chart.parentElement;
    var heading = panel.querySelector('h3');
    var wrapper = document.createElement('div');
    wrapper.className = 'vf-chart-scroll';
    wrapper.tabIndex = 0;
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', (heading ? heading.textContent : 'Chart') + ' - scroll horizontally to view');
    chart.before(wrapper);
    wrapper.appendChild(chart);
  });
}
vyvPrepareArticleCharts();
document.addEventListener('shopify:section:load', vyvPrepareArticleCharts);
